import Link from 'components/ui/AppLink';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

import { useParams } from 'react-router-dom';
import { GET_CHARTS_ARTICLES } from '../../../gql/articles';
import { CHARTS_LOGO } from '../../../config';
import { getArticleLink } from '../../../utils/link.utils';

import { useQuery } from '@apollo/react-hooks';
import { Grid } from '@mui/material';

interface ChartArticleCardInterface {
    _id: string;
    title: string;
    summary: string;
}

const ChartArticleCard = (props: ChartArticleCardInterface) => {
    const { _id, title, summary } = props;

    const articleLink = getArticleLink(_id);

    return (
        <Paper sx={{ width: '100%', height: '100%', p: 3 }}>
            <Box
                sx={{
                    mb: 1,
                }}
            >
                <img src={CHARTS_LOGO} alt="chart-logo" />
            </Box>
            <Box
                sx={{
                    mb: 1,
                }}
            >
                <Link to={articleLink} color="inherit">
                    <Typography
                        variant="h6"
                        component="span"
                        sx={{ color: 'link.default' }}
                    >
                        {title}
                    </Typography>
                </Link>
            </Box>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Typography
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {summary}
                </Typography>
            </Box>
        </Paper>
    );
};

const ChannelChartsArticles: React.FC = () => {
    const { channelId } = useParams<{ channelId: string }>();

    const { data } = useQuery(GET_CHARTS_ARTICLES, {
        variables: { premiumChannelId: channelId },
        fetchPolicy: 'network-only',
    });

    const chartArticles = data?.getChartsArticles || [];

    return chartArticles.length ? (
        <Grid container spacing={2}>
            <Grid size={12}>
                <Typography variant="body1">Charts</Typography>
            </Grid>
            <Grid size={12}>
                <Grid container spacing={2}>
                    {chartArticles.map(
                        (ca: ChartArticleCardInterface, key: number) => (
                            <Grid
                                key={key}
                                size={{
                                    xs: 6,
                                    md: 4,
                                }}
                            >
                                <ChartArticleCard
                                    _id={ca._id}
                                    title={ca.title}
                                    summary={ca.summary}
                                />
                            </Grid>
                        )
                    )}
                </Grid>
            </Grid>
        </Grid>
    ) : (
        <></>
    );
};

export default ChannelChartsArticles;
